<div [ngStyle]="{ 'display' : this.azimuthToolController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  id="ngAzimuthForm" [ngClass]="[this.azimuthToolController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" name="ngAzimuthForm" #ngAzimuthForm="ngForm" id="azimuthForm">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Coordenates</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Latitude</label>
            <div class="coordenates">
              <select  [(ngModel)]="azimuthToolController.latLonDms.latitude.cardinal"
            (ngModelChange)="azimuthToolController.latitude = azimuthToolController.latLonDms.toLat()
            " name="latCardSelect" style="width: 12%;">
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
              <input name="latitudeDegrees"  [(ngModel)]="azimuthToolController.latLonDms.latitude.degrees
            "
            (ngModelChange)="
            azimuthToolController.latitude = azimuthToolController.latLonDms.toLat();
            " type="number" style="width: 24%;" />
                <span>º</span>
              <input  name="latMinutes"
              [(ngModel)]="
              azimuthToolController.latLonDms.latitude.minutes
              "
              (ngModelChange)="
              azimuthToolController.latitude = azimuthToolController.latLonDms.toLat();
              " type="number" style="width: 24%;" />
                <span>´</span>
              <input  name="latSeconds"
              [(ngModel)]="
              azimuthToolController.latLonDms.latitude.seconds
              "
              (ngModelChange)="
              azimuthToolController.latitude = azimuthToolController.latLonDms.toLat();
              " type="number" style="width: 24%;" />
                <span>"</span>
                <br/>
              <input [(ngModel)]="azimuthToolController.latitude" name="latitude" type="number" style="width: 93%; margin-top: 10px;" 
                    (ngModelChange)="azimuthToolController.latLonDms.fromLat(azimuthToolController.latitude)"/>
                <span>"</span>
            </div>
          </div>
          <div>
            <label for="">Longitude</label>
            <div class="coordenates">
              <select [(ngModel)]="azimuthToolController.latLonDms.longitude.cardinal"
              (ngModelChange)="azimuthToolController.longitude = azimuthToolController.latLonDms.toLon()
              " name="lonCardSelect" style="width: 12%;">
                <option value="W">W</option>
                <option value="E">E</option>
              </select>
              <input name="longitudeDegrees"  [(ngModel)]="azimuthToolController.latLonDms.longitude.degrees
              "
              (ngModelChange)="
              azimuthToolController.longitude = azimuthToolController.latLonDms.toLon();
              " type="number" style="width: 24%;" />
                <span>º</span>
              <input name="lonMinutes"
              [(ngModel)]="
              azimuthToolController.latLonDms.longitude.minutes
              "
              (ngModelChange)="
              azimuthToolController.longitude = azimuthToolController.latLonDms.toLon();
              " type="number" style="width: 24%;" />
                <span>´</span>
              <input name="lonSeconds"
              [(ngModel)]="
              azimuthToolController.latLonDms.longitude.seconds
              "
              (ngModelChange)="
              azimuthToolController.longitude = azimuthToolController.latLonDms.toLon();
              " type="number" style="width: 24%;" />
                <span>"</span>
                <br/>
              <input [(ngModel)]="azimuthToolController.longitude" name="longitude" type="number" style="width: 93%; margin-top: 10px;" 
                    (ngModelChange)="azimuthToolController.latLonDms.fromLon(azimuthToolController.longitude)"/>
                <span>"</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Parameters</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Line Length</label>
            <div class="coordenates"><input name="lineLength" [(ngModel)]="azimuthToolController.distance" type="number" style="width: 80%;" /><span>[NM]</span></div>
          </div>
          <div>
            <label for="">Angle Increment</label>
            <div class="coordenates"><input name="angleIncrement" [(ngModel)]="azimuthToolController.angleIncrement" type="number" style="width: 80%;" /><span>º</span></div>
          </div>
          <div>
            <label for="">Angle Offset</label>
            <div class="coordenates"><input name="angleOffset" [(ngModel)]="azimuthToolController.angleOffset" type="number" style="width: 80%;" /><span>º</span></div>
          </div>
          <div>
            <div class="btn" style="padding: 10px 10px 10px 0;">
              <button (click)="this.azimuthToolController.drawAngles();">Draw Angles</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </form>
</div>
